import React from 'react';
import './index.css';



function Header() {
  return (
    <div>

      <h1 className="header">
        <a href="#gallery">
          Mayumi<br/>
          Ishino<br/>
        </a>
      </h1>

      <p className="tagline">Tokyo-born, Brooklyn-based interdisciplinary artist.</p>
    </div>
  );
}

export default Header;
